import $constants from '@/const';

export default {
    state: {
        currentChat: { isLoaded: false },
        messageDraft: '',

        ratingPending: false,
        responsePending: false,
        escalationPending: false,
    },
    actions: {
        setChatData({ commit }, chatData) {
            commit("SET_CHAT_DATA", chatData);
        },
        async startChat({ commit }, payload) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.startChat,
                payload: payload,
            });

            if (result && result.data) {
                commit("SET_CHAT_DATA", result.data.data);
                return result.data.data;
            }

            return false;
        },
        async getChat({ commit }, payload) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.getChat,
                payload: payload,
            });

            if (result && result.data) {
                commit("SET_CHAT_DATA", result.data.data);
                return result.data.data;
            }

            return false;
        },
        async postChatMessage({ state, commit }, payload) {

            commit("SET_MESSAGE_DRAFT", payload.message);

            commit("SET_CHAT_MESSAGES", [...state.currentChat.messages, {
                message: payload.message,
                role: $constants.CHAT_MESSAGE_ROLE__USER,
                sent: new Date().toISOString(),
            }]);

            commit("SET_RESPONSE_PENDING", true);

            const result = await this.makeRequest({
                reqFunc: this.apiService.postChatMessage,
                payload: payload,
            });

            commit("SET_RESPONSE_PENDING", false);

            if (result && result.data) {
                commit("SET_CHAT_DATA", result.data.data);
                commit("SET_MESSAGE_DRAFT", '');
                return result.data.data;
            }

            return false;
        },

        async endChat({ commit }, payload) {
            
            const result = await this.makeRequest({
                reqFunc: this.apiService.endChat,
                payload: payload,
            });

            if (result && result.data) {
                commit("SET_CHAT_DATA", result.data.data);
                return result.data.data;
            }

            return false;
        },
        
        async rateResponse({ commit }, payload) {

            commit("SET_RATING_PENDING", true);

            const result = await this.makeRequest({
                reqFunc: this.apiService.rateBotResponse,
                payload: payload,
            });

            commit("SET_RATING_PENDING", false);

            if (result && result.data) {
                return result.data.data;
            }

            return false;
        },
        
        setEscalationPending({ commit }, value) {
            commit("SET_ESCALATION_PENDING", value);
        },

        async escalateChat(_, payload) {

            const result = await this.makeRequest({
                reqFunc: this.apiService.escalateChat,
                payload: payload,
            });

            if (result && result.data) {
                return result.data.data;
            }

            return false;
        },

        async declineEscalation({ commit }, payload) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.declineEscalation,
                payload: payload,
            });

            if (result && result.data) {
                commit("SET_CHAT_DATA", result.data.data);
                return result.data.data;
            }

            return false;
        },
    },
    mutations: {
        SET_CHAT_DATA(state, data) {
            state.currentChat = {
                ...data,
                isLoaded: true,
            };
        },
        SET_CHAT_MESSAGES(state, data) {
            state.currentChat.messages = data;
        },
        SET_MESSAGE_DRAFT(state, value) {
            state.messageDraft = value;
        },
        SET_RATING_PENDING(state, value) {
            state.ratingPending = value;
        },
        SET_RESPONSE_PENDING(state, value) {
            state.responsePending = value;
        },
        SET_ESCALATION_PENDING(state, value) {
            state.escalationPending = value;
        },
    },
    getters: {
        currentChat: state => state.currentChat,
        currentChatId: state => state.currentChat?.chatId || 0,
        currentChatMessages: state => state.currentChat?.messages || [],
        
        messageDraft: state => state.messageDraft,
        ratingPending: state => state.ratingPending,
        responsePending: state => state.responsePending,
        escalationPending: state => state.escalationPending,
    }
}